import React from 'react';
import './LegalPages.css';

const About = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>About Timepass Game</h1>
        
        <div className="legal-content">
          <section>
            <h2>Welcome to Timepass Game</h2>
            <p>
              We create fun, educational online games that help you relax, learn, and challenge yourself. All our games are free and designed for players of all ages.
            </p>
          </section>

          <section>
            <h2>Our Games</h2>
            
            <div className="game-category">
              <h3>💎 Gem Quest</h3>
              <p>An exciting match-3 puzzle adventure with colorful gems and sparkling jewels. Create powerful combos, unlock special effects, and progress through challenging levels in this addictive gem-matching game.</p>
            </div>

            <div className="game-category">
              <h3>🌍 Country Knowledge Quiz</h3>
              <p>Test your geography knowledge with questions about countries, capitals, and currencies. Compete on global leaderboards and learn fascinating facts about the world.</p>
            </div>

            <div className="game-category">
              <h3>🎯 Secret Number Game</h3>
              <p>A mathematical puzzle that challenges your logical thinking. Guess the hidden number using strategic hints and improve your problem-solving skills.</p>
            </div>

            <div className="game-category">
              <h3>🐍 Snake Game</h3>
              <p>The classic arcade game that never gets old. Control your snake, eat food, and avoid obstacles while improving your reflexes and coordination.</p>
            </div>

            <div className="game-category">
              <h3>🧩 Image Puzzles</h3>
              <p>Beautiful tiger and lion puzzle games that test your spatial reasoning and visual perception. Arrange scrambled pieces to recreate stunning wildlife images.</p>
            </div>

            <div className="game-category">
              <h3>🎲 Tools & Utilities</h3>
              <p>Productive digital tools including character counter for text analysis, greeting cards generator for personalized messages, and interactive decision-making wheels (number spinners, month selectors, truth-or-dare wheels).</p>
            </div>
          </section>

          <section>
            <h2>Why Choose Our Games?</h2>
            <div className="features-grid">
              <div className="feature">
                <h3>🆓 Always Free</h3>
                <p>All games and tools are completely free with no hidden costs.</p>
              </div>
              <div className="feature">
                <h3>📱 Play Anywhere</h3>
                <p>Works on desktop, tablet, and mobile devices.</p>
              </div>
              <div className="feature">
                <h3>🚫 No Downloads</h3>
                <p>Play instantly in your browser.</p>
              </div>
              <div className="feature">
                <h3>🏆 Compete & Learn</h3>
                <p>Track scores and compete on leaderboards while learning.</p>
              </div>
              <div className="feature">
                <h3>👨‍👩‍👧‍👦 Family Friendly</h3>
                <p>Safe, appropriate content for all ages.</p>
              </div>
              <div className="feature">
                <h3>🔒 Privacy Focused</h3>
                <p>We respect your privacy and collect minimal data.</p>
              </div>
            </div>
          </section>

          <section>
            <h2>Educational Benefits</h2>
            <ul>
              <li><strong>Geography:</strong> Learn about countries, capitals, and currencies through our quiz</li>
              <li><strong>Mathematics:</strong> Improve logical reasoning with number games</li>
              <li><strong>Pattern Recognition:</strong> Develop visual skills through match-3 and puzzle games</li>
              <li><strong>Problem Solving:</strong> Develop critical thinking through diverse puzzles</li>
              <li><strong>Memory:</strong> Enhance recall through strategic gameplay</li>
              <li><strong>Coordination:</strong> Improve reflexes with action and arcade games</li>
              <li><strong>Creativity:</strong> Express yourself through our greeting cards generator</li>
              <li><strong>Decision Making:</strong> Use interactive tools for choices and planning</li>
            </ul>
          </section>

          <section>
            <h2>Get Started</h2>
            <p>
              Ready to play? Choose any game from our collection and start having fun while learning. Whether you have 5 minutes or an hour, there's something here for every mood.
            </p>
            <p>
              Have questions or feedback? Contact us - we'd love to hear from you!
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
